import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Input } from '@DesignSystem/controllers';
import styles from './APIKeyInput.module.scss';
import { DSCloseIcon, DSRefreshIcon } from '@ds-icons';
import { Tooltip } from '@ds';
import isEmpty from 'lodash/isEmpty';

const APIKeyInputWritable = ({ title, value, onChange, ...restProps }) => {
  const originalValue = useRef(value);
  const [hasEdited, setHasEdited] = useState(false);

  const handleFocus = () => {
    if (hasEdited) return;
    onChange('');
  };

  const handleBlur = () => {
    if (hasEdited) return;
    onChange(originalValue.current);
  };

  const handleInputChange = value => {
    setHasEdited(true);
    onChange(value);
  };

  const resetInput = () => {
    onChange(originalValue.current);
    setHasEdited(false);
  };

  const clearInput = () => {
    onChange('');
    setHasEdited(true);
  };

  const renderPostFixIcon = () => {
    if (isEmpty(originalValue.current)) return null;

    if (hasEdited)
      return (
        <Tooltip content="Reset" wrapper={false}>
          <div onClick={resetInput} className={styles.resetIconContainer}>
            <DSRefreshIcon />
          </div>
        </Tooltip>
      );

    if (value === originalValue.current) {
      return (
        <Tooltip content="Clear" wrapper={false}>
          <div onClick={clearInput} className={styles.resetIconContainer}>
            <DSCloseIcon />
          </div>
        </Tooltip>
      );
    }

    return null;
  };

  return (
    <div
      className={cx(styles.APIInputContainer, styles.APIInputContainerHidden)}
    >
      <Input
        title={title}
        value={value}
        lineHeight="21px"
        PostfixIcon={renderPostFixIcon}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        inputType="text"
        {...restProps}
      />
    </div>
  );
};

APIKeyInputWritable.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string
};

APIKeyInputWritable.defaultProps = {
  value: '',
  title: ''
};

export default APIKeyInputWritable;
